<script setup>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import { v4 as uuid } from 'uuid';
import TrafficSourceCost from "./TrafficSourceCost";
import { defaultTrafficSourceGroup } from "../utils/trafficSourceCostsUtils";

const { getters } = useStore();
const props = defineProps({
  isNew: {
    type: Boolean
  },
  trafficSourceCosts: {
    type: Array,
    required: true,
  },
  update: {
    type: Function,
    required: true,
  },
  currency: {
    type: String,
    default: "",
  },
  useInvoice: {
    type: Boolean,
    default: true,
  },
});
const trafficSourcesEnum = computed(() => getters["trafficSources/list"])
const sourceIndexes = computed(() => trafficSourcesEnum.value.map(item => item.source))

onMounted(() => {
  if (props.trafficSourceCosts.length === 0 && props.isNew) {
    props.update([{...defaultTrafficSourceGroup, key: uuid(), sourceIndexes }]);
  }
})

const handleRemove = (index) => {
  const updatedCosts = [...props.trafficSourceCosts];
  updatedCosts.splice(index, 1);
  props.update(updatedCosts)
};

const handleAdd = () => {
  props.update([
    {
      ...defaultTrafficSourceGroup,
      key: uuid(),
      sourceIndexes: props.trafficSourceCosts.length === 0 ? sourceIndexes : []
    },
    ...props.trafficSourceCosts,
  ]);
};

const handleUpdate = (index, {field, value}) => {
  const updatedCosts = props.trafficSourceCosts.map((item, i) => {
    if (i === index) {
      return { ...item, [field]: value }
    } else if (field === 'sourceIndexes') {
      return { ...item, sourceIndexes: item.sourceIndexes.filter(source => !value.includes(source)) }
    }

    return item
  })

  props.update(updatedCosts);
};
</script>
<template>
  <div v-if="trafficSourcesEnum.length">
    <button
      v-if="trafficSourceCosts.length < trafficSourcesEnum.length"
      type="button"
      class="secondary"
      @click="handleAdd"
    >
      <plus-icon /><span>Add Payment</span>
    </button>
    <div class="traffic-sources-container">
      <div
        v-for="(trafficSourceCost, index) in trafficSourceCosts"
        :key="index"
        class="traffic-sources"
      >
        <TrafficSourceCost
          :index="index"
          :currency="currency"
          :traffic-source-cost="trafficSourceCost"
          :traffic-sources="trafficSourcesEnum"
          :use-invoice="useInvoice"
          @update="(value) => handleUpdate(index, value)"
          @remove="() => handleRemove(index)"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.traffic-sources-container {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &:deep(* + *) {
    margin-top: initial;
  }
}

button.secondary {
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  padding: 14px 30px;
  border-radius: 2px;
  border: 2px solid #000;
  font-weight: 500;
  background: #fff;
  font-size: 16px;
  line-height: 24px;

  & > span {
    margin: 0;
  }

  & > svg {
    width: 24px;
    height: 24px;
  }
}
</style>
